import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { IAxiosDefaultDataObject } from '../../config'
import { updateGlobalLoaderStatus, updateQuickNotificationDetails } from '../notifications/notificationsSlice'
import { usePageDetails } from './adminPagesSlice'
import BaseApp, { IBaseAppDataDisplayerColumn, replaceItemDataInLink } from '../BaseApp'
import { handleRequestError } from '../../services/api'
import PageHeadSection from './components/PageHeadSection'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import NotFound from '../../components/NotFound'
import BasicDataViewer, { BasicDataViewerItemTypes, IBasicDataViewItem } from '../../components/DataDisplayer/BasicDataViewer'
import { Avatar } from '@mui/material'
import GenerateIcon from '../../components/GenerateIcon'
import Thumbnail from '../../components/Thumbnail'
import { currentUserDetails, useReturnCurrentUser } from '../user/userSlice'
import BasicModalWindow from '../../components/BasicModalWIndow'

interface IProps {
    additionalContent?: () => JSX.Element,
    customId?: number,
    hidePageSection?: boolean,
    customPage?: string,
}

interface IDynamicItemViewContentPageProps {
    item: IAxiosDefaultDataObject,
    columns: Array<IBaseAppDataDisplayerColumn>,
    additionalContent?: () => JSX.Element
}

const DynamicItemViewContentPage = (props: IDynamicItemViewContentPageProps) => {

    const { columns, additionalContent } = props
    
    const [item, setItem] = useState<IAxiosDefaultDataObject>({})
    const [basicDataViewerItems, setBasicDataViewerItems] = useState<Array<IBasicDataViewItem>>([])

    useEffect(() => {
        setItem(props.item)
    }, [props.item])

    useEffect(() => {

        let createItems: Array<IBasicDataViewItem> = []

        columns.map((column) => {

            if (column.type !== "thumbnail"){
                let columnItem: IBasicDataViewItem = {
                    type:  (column.type as BasicDataViewerItemTypes),
                    label: column.label,
                    value: item[column.id],
                }

                if (column.customContent){
                    columnItem.customContent = () => column.customContent ? column.customContent(item) : <></>
                }

                createItems.push(columnItem)
            }
        })

        setBasicDataViewerItems(createItems)

    }, [item])

    return(
        <div className="admin-single-item-view-page-container">
            <div className="content-of-admin-single-item-view-page-container">

                <div className="sections-of-admin-single-item-view-page-container">
                    <div className="content-of-sections-of-admin-single-item-view-page-container">

                        <div className="section-of-admin-single-item-view-page-container thumbnail">
                            <div className="content-of-section-of-admin-single-item-view-page-container">
                                <SectionBoxContainer>
                                    {/* {item.thumbnail ? <img src={item.thumbnail} /> :  <Avatar><GenerateIcon icon="image" /></Avatar>} */}
                                    <Thumbnail src={item.thumbnail} />
                                </SectionBoxContainer>
                            </div>
                        </div>

                        <div className="section-of-admin-single-item-view-page-container text">
                            <div className="content-of-section-of-admin-single-item-view-page-container">
                                <SectionBoxContainer showTitle title="Details" description="Here are the items details">
                                    <BasicDataViewer items={basicDataViewerItems} />
                                    {additionalContent ? additionalContent() : ""}
                                </SectionBoxContainer>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    )
}

export default function DynamicItemViewPage(props: IProps) {

    const { additionalContent, customId, hidePageSection, customPage } = props

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const params = useParams()

    const itemId = customId ? customId : params.id ? Number(params.id) : 0

    const [item, setItem] = useState<IAxiosDefaultDataObject>({})

    const [notFound, setNotFound] = useState<boolean>(false)
    const [undoTimeout, setUndoTimeout] = useState<NodeJS.Timeout | null>(null)

    const uploadLoader = (status: boolean) => dispatch(updateGlobalLoaderStatus({ status: status }))

    const currentPage = usePageDetails(customPage ? customPage : params.page_name ? params.page_name : "")
    const currentUser = useReturnCurrentUser()

    const baseApp = currentPage.appClass ? currentPage.appClass : new BaseApp()

    const [managePersmission, setManagePersmission] = useState<boolean>(false)
    const [sureToDeleteWindow, setSureToDeleteWindow] = useState<boolean>(false)

    /**
     * Load item
     */
    const loadItem = () => {
        uploadLoader(true)

        baseApp.singleInstanceDetails(itemId)
            .then(response => {

                const result: IAxiosDefaultDataObject = response.data
                setItem(result)


                setNotFound(false)
                uploadLoader(false)

            })
            .catch(error => {

                const { status } = error.response

                handleRequestError(error, dispatch)

                if (status == 404){
                    setNotFound(true)
                }

                uploadLoader(false)

            })
    }
 

    /**
     * Handle before delete
     */
    const handleBeforeDelete = () => {
        setNotFound(false)
        dispatch(updateGlobalLoaderStatus({ status: false }))

        if (undoTimeout){
            clearTimeout(undoTimeout)
        }
    }

    /**
     * Delete item
     */
    const handleDeleteItem = () => {
    
        dispatch(updateGlobalLoaderStatus({ status: true }))

        setNotFound(true)

        updateQuickNotificationDetails(true, "Item has been deleted", "error", dispatch, () => {}, 5000, false, [
            {
                label: "Close",
                handleClose: true
            },
            // {
            //     label: "Undo",
            //     handleClose: false,
            //     onClick: () => handleBeforeDelete()
            // }
        ])

        // const timeout = setTimeout(() => {
        //     dispatch(updateGlobalLoaderStatus({ status: false }))
        //     baseApp.deleteInstance(item.id)
        //     .then(response => {
        //         navigate("/panel/" + currentPage.name)
        //     })
        //     .catch(error => {
        //         handleRequestError(error, dispatch)
        //     })
        // }, 5000);
    
        // setUndoTimeout(timeout);

    }


    /**
     * Load item
     */
    useEffect(() => {
        loadItem()
    }, [itemId])

    useEffect(() => {
        if (currentUser.is_superuser || currentUser.is_daemon){
            setManagePersmission(true)
        }
    }, [currentUser])

    return(
        <div>

            <BasicModalWindow
                shown={sureToDeleteWindow}
                size="sm"
                title="Delete"
                showHeader
                actionButtons={[
                    {
                        color: "error",
                        label: "Cancel",
                        onClick: () => setSureToDeleteWindow(false)
                    },
                    {
                        color: "success",
                        label: "Delete",
                        onClick: () => handleDeleteItem()
                    }
                ]}
                actionButtonsBottom
                handleClose={() => setSureToDeleteWindow(false)}
            >
                <p>{!notFound ? item.title ? `Are you sure that you want to delete '${item.title}'` : "Are you sure that you want to delete this item?" : "---"}</p>
            </BasicModalWindow>

            {!hidePageSection && (
                <PageHeadSection 
                    pageName={currentPage.name} 
                    customTitle={notFound ? "404" : item.title ? item.title : ""} 
                    customActionButtons={managePersmission ? [
                        {
                            icon: "delete",
                            variant: "text",
                            label: "Delete",
                            color: "error",
                            onClick: () => setSureToDeleteWindow(true)
                        },
                        {
                            icon: "edit",
                            variant: "text",
                            link: replaceItemDataInLink(`/panel/${currentPage.name}/edit/[id]`, item),
                            label: "edit",
                            color: "success"
                        }
                    ] : []}
                />
            )}

            {notFound && <SectionBoxContainer><NotFound message={baseApp.dataDisplayer.notionFound.message} /></SectionBoxContainer>}
            {!notFound && <DynamicItemViewContentPage item={item} columns={baseApp.dataDisplayer.columns} additionalContent={additionalContent} />}

        </div>
    )
}